import { APPROACH, SECTION_HEADS } from '../../content/site';
import m from '../../styles/marketing.module.css';
import SectionHeader from './SectionHeader';
import styles from './Sections.module.css';

/** Our approach: four numbered nodes on a vertical rail beside a photo. */
const Approach = ({ tint = false }: { tint?: boolean }) => (
  <section className={`${m.section} ${tint ? m.tint : ''}`} id="approach">
    <div className={m.container}>
      <SectionHeader {...SECTION_HEADS.approach} />
      <div className={`${styles.withPhoto} ${styles.withPhotoRight}`}>
        <ol className={`${styles.rail} ${styles.railStacked}`}>
          {APPROACH.map((step, i) => (
            <li key={step.name} className={styles.step} data-reveal data-reveal-delay={i * 90}>
              <span className={styles.node}>{String(i + 1).padStart(2, '0')}</span>
              <div>
                <h3>{step.name}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className={`${m.photo} ${m.cutRight} ${styles.sidePhoto}`} data-reveal>
          <img
            src="/images/advisory-walk.webp"
            alt="Two colleagues in conversation walking down a sunlit corridor"
            data-parallax="0.04"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Approach;
